import { Modal } from 'antd';
import React from 'react';
import ClockImage from '@/assets/images/clock.png';
import DiamondImage from '@/assets/images/diamond.png';
import { useTier } from '@/store/userStore';
import { LockOutlined, TrophyOutlined } from '@ant-design/icons';
import { useSettings } from "@/store/settingStore";
import { ThemeMode } from "#/enum";
const ZeroCreditsModal = ({
  open,
  onClose
}) => {
  const tier = useTier();
  const {
    themeMode
  } = useSettings();
  const isDark = themeMode === ThemeMode.Dark;
  const planName = tier && tier.toLowerCase() !== 'trial' && tier.toLowerCase() !== 'free' ? `${tier.charAt(0).toUpperCase() + tier.slice(1)} Plan` : 'Free Trial';
  return <Modal open={open} onCancel={onClose} footer={null} centered maskClosable>
        <div className={`w-full flex flex-col gap-y-4 ${isDark ? 'text-white' : 'text-gray-900'}`}>
            <div className='mx-auto w-[80px] h-[80px] rounded-full flex items-center justify-center mt-2'>
                <img src={ClockImage} alt='clock-image' className='w-full h-full object-contain' />
            </div>
            <div className='w-full flex-col text-center h-max'>
                <p className='text-2xl font-bold tracking-tight'>Credits Exhausted</p>
            </div>
            <div className='w-10/12 text-center mx-auto'>
              <span className={`text-[15px] font-medium leading-relaxed ${isDark ? 'text-gray-400' : 'text-gray-600'}`}>
                Your {planName.toLowerCase()} credits have been exhausted. Upgrade your plan to continue using VantageAI features.
              </span>
            </div>

            <div className={`w-full p-4 h-[75px] rounded-xl border mt-2 flex items-center justify-between ${isDark ? 'bg-[#C41230]/10 border-[#C41230]/20' : 'bg-[#C41230]/5 border-[#C41230]/10'}`}>
                  <div className='flex items-center h-full gap-3.5'>
                        <TrophyOutlined style={{
            fontSize: "22px",
            color: "#C41230"
          }} />
                        <div className='flex flex-col text-left'>
                          <span className={`text-[13px] font-bold ${isDark ? 'text-gray-200' : 'text-gray-900'}`}>Don't lose access to premium features</span>
                          <span className={`text-[12px] font-medium ${isDark ? 'text-gray-400' : 'text-gray-500'}`}>Upgrade today and keep everything you love.</span>
                        </div>
                  </div>
                  <img src={DiamondImage} alt="Diamond" className='w-[36px] h-[36px] object-contain opacity-90' />
            </div>

            <div className='w-full flex items-center justify-center gap-2 mt-2'>
              <LockOutlined className={isDark ? 'text-gray-500' : 'text-gray-400'} />
              <span className={`text-[12px] font-semibold ${isDark ? 'text-gray-500' : 'text-gray-400'}`}>Secure & hassle-free upgrade</span>
            </div>
        </div>
    </Modal>;
};
export default ZeroCreditsModal;